"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParagraphIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var withSVGIcon_1 = require("../withSVGIcon");
var Icon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? '#000' : _b;
    return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: jsx_runtime_1.jsx("path", { d: "M10.7896 19H12.0225V15.2812H14.2498C16.6213 15.2812 17.6902 13.8395 17.6902 12.0398C17.6902 10.2401 16.6213 8.81818 14.2299 8.81818H10.7896V19ZM12.0225 14.1875V9.91193H14.1902C15.8457 9.91193 16.4771 10.8168 16.4771 12.0398C16.4771 13.2628 15.8457 14.1875 14.21 14.1875H12.0225Z", fill: fill }, void 0) }, void 0));
};
exports.ParagraphIcon = withSVGIcon_1.withSVGIcon(Icon, { viewBox: '0 0 28 29' });
//# sourceMappingURL=ParagraphIcon.js.map